const userRole = {
  カンパニー管理者: 2,
  サブカンパニー管理者: 3,
  一般ユーザー: 4,
}

export default userRole
